import React, { Component } from "react";
import { notify } from "react-notify-toast";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { bindActionCreators } from "redux";
import createHistory from "history/createBrowserHistory";
import {
  actionProcessingJobs,
  updateStatusAction,
  cancelReasonAction,
} from "../../actions/index";
import CancelJob from "./CancelJob";
import ClockImage from "../../images/clock.svg";
import api from "../../utility/api/api.js";
import GetTime from "../GetTime.js";
import DelayMinutes from "./DelayMinutes";
import OrderId from "./OrderId";
import AcceptModal from "./AcceptModal";
class JobsComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { acceptData: "", getupdatestatusJob: "" };
    const history = createHistory();
  }
  componentWillMount() {
    api.getCancelResonsList(this);
  }
  startShiping = (e, job_id) => {
    console.log("IntransitGuna");
    if (this.props.jobs && this.props.jobs !== "failure") {
      notify.show("Please Complete In Progress Trip", "success", 1000);
      e.preventDefault();
      return;
    } else {
      this.props.actionProcessingJobs(null);
      api.updateriderstatus(this, job_id);
      console.log("this.props.statusUpdate", this.state.getupdatestatusJob);
      if (
        this.state.getupdatestatusJob &&
        this.state.getupdatestatusJob == "in-transit"
      ) {
        api.callShippingJobs(this, job_id);
      }
    }
  };
  cancelShiping = (job_id) => {
    console.log("haha", job_id);
    api.rejectRiderTrip(job_id);
  };
  inCompleteFunction = () => {
    if (this.state.acceptData && this.state.acceptData[0].data.length > 0) {
      this.state.acceptData[0].data.shift();
    }
  };
  render() {
    console.log("acceptDataacceptData", this.state.acceptData);

    const trips = this.props.jobsobject;
    const intransitJob = this.props.intransitJob;
    console.log("tripstrips", trips);
    return (
      <div className="spn-jobs">
        {intransitJob && intransitJob != "failure" && (
          <div className="spn-jobs-item py-2" key={"intransitJob"}>
            <Row>
              <Col xs="6" md="auto">
                <div>
                  JID: <b>{intransitJob[0].job_id} </b>
                </div>
              </Col>
              {(intransitJob[0].loyalty_tier || intransitJob[0].customer_tag) && (
                <Col xs="12" md className="order-last order-md-0 d-md-flex">
                  <div className="mr-md-4">
                    Loyalty Tier: <b>{intransitJob[0].loyalty_tier || "-"}</b>
                  </div>
                  <div>
                    Customer Tag: <b>{intransitJob[0].customer_tag || "-"}</b>
                  </div>
                </Col>
              )}
              <Col xs="6" md="auto" className="d-flex justify-content-end ml-auto text-nowrap">
                <img src={ClockImage} alt="clock" />{" "}
                <GetTime time={intransitJob[0].assigned_at} />
              </Col>
            </Row>
            <Row className="py-2 px-4">
              <Col className="text-center py-3">
                <span className="spn-jobs-item-box spn-jobs-item-box_border">
                  <span className="spn-jobs-item-box-number">
                    <OrderId
                      orderids={intransitJob[0].order_increment_ids}
                      totalOrder={intransitJob[0].order_count}
                    />
                  </span>
                  <span className="spn-jobs-item-box-name">Orders</span>
                </span>
              </Col>
              <Col className="text-center  py-3">
                <span className="spn-jobs-item-box">
                  <span className="spn-jobs-item-box-number">
                    {parseInt(intransitJob[0].box) < 10 &&
                    parseInt(intransitJob[0].box) > 0
                      ? "0" + intransitJob[0].box
                      : intransitJob[0].box}
                  </span>
                  <span className="spn-jobs-item-box-name">Bags</span>
                </span>
              </Col>
            </Row>
            {/* <Row className="py-2">
              <Col
                id={`picked_${intransitJob[0].job_id}`}
                className="text-center spn-jobs-pickedby"
              >
                To be delivered by:{" "}
                <GetTime time={intransitJob[0].delivered_by} />
              </Col>
            </Row>
            <DelayMinutes
              job_id={intransitJob[0].job_id}
              time={intransitJob[0].delivered_by}
            /> */}
            <Row className="box-shadow">
              <NavLink to="/intransit" className="intransitContinue">
                Continue
              </NavLink>
            </Row>
          </div>
        )}
        {trips &&
          trips.map((obj, i) => (
            <div className="spn-jobs-item py-2" key={i}>
              <Row>
                <Col xs="6" md="auto">
                  <div>
                    JID: <b>{obj.job_id} </b>
                  </div>
                </Col>
                {(obj.loyalty_tier || obj.customer_tag) && (
                  <Col xs="12" md className="order-last order-md-0 d-md-flex">
                    <div className="mr-md-4">
                      Loyalty Tier: <b>{obj.loyalty_tier || "-"}</b>
                    </div>
                    <div>
                      Customer Tag: <b>{obj.customer_tag || "-"}</b>
                    </div>
                  </Col>
                )}
                <Col xs="6" md="auto" className="d-flex justify-content-end ml-auto text-nowrap">
                  <img src={ClockImage} alt="clock" />{" "}
                  <GetTime time={obj.assigned_at} />
                </Col>
              </Row>
              <Row className="py-2 px-4">
                <Col className="text-center py-3">
                  <span className="spn-jobs-item-box spn-jobs-item-box_border">
                    <span className="spn-jobs-item-box-number">
                      <OrderId
                        orderids={obj.order_increment_ids}
                        totalOrder={obj.order_count}
                      />
                    </span>
                    <span className="spn-jobs-item-box-name">Orders</span>
                  </span>
                </Col>
                <Col className="text-center  py-3">
                  <span className="spn-jobs-item-box">
                    <span className="spn-jobs-item-box-number">
                      {parseInt(obj.box) < 10 && parseInt(obj.box) > 0
                        ? "0" + obj.box
                        : obj.box}
                    </span>
                    <span className="spn-jobs-item-box-name">Bags</span>
                  </span>
                </Col>
                {/* <Col className="text-center py-3">
                  <span className="spn-jobs-item-box">
                    <span className="spn-jobs-item-box-number">
                      {obj.total_order_weight}
                    </span>
                    <span className="spn-jobs-item-box-name">Weight in KG</span>
                  </span>
                </Col> */}
              </Row>
              {/* <Row className="py-2">
                <Col
                  id={`picked_${obj.job_id}`}
                  className="text-center spn-jobs-pickedby"
                >
                  To be delivered by: <GetTime time={obj.delivered_by} />
                </Col>
              </Row> */}
              {/* <DelayMinutes job_id={obj.job_id} time={obj.delivered_by} /> */}
              <Row className="box-shadow">
                <Col className="p-0">
                  <CancelJob
                    // className="spn-jobs-decisionbutton btn"
                    trip_id={obj.job_id}
                    // onClick={() => this.cancelShiping(obj.job_id)}
                    label="Reject"
                  />
                </Col>
                <Col className="p-0">
                  <NavLink
                    onClick={(e) => this.startShiping(e, obj.job_id)}
                    to={{ pathname: "/intransit", value: obj.job_id }}
                  >
                    <button
                      className="spn-jobs-decisionbutton btn spn-jobs-decisionbutton-start"
                      id={obj.job_id}
                    >
                      SHIP
                    </button>
                  </NavLink>
                </Col>
              </Row>
            </div>
          ))}

        {/* {this.state.acceptData &&
        this.state.acceptData[0] &&
        this.state.acceptData[0].status == "success" ? (
          this.state.acceptData &&
          this.state.acceptData[0] &&
          this.state.acceptData[0].data &&
          this.state.acceptData[0].data.length > 0 ? (
            <AcceptModal
              incompletefn={this.inCompleteFunction}
              acctda={this.state.acceptData[0].data[0]}
            />
          ) : null
        ) : null} */}
      </div>
    );
  }
}
function mapStateToProps(state) {
  console.log("checklistjobs", state);
  return {
    jobs: state.processingJobs,
    statusUpdate: state.getupdateStatus,
    intransitJob: state.intransitJob,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionProcessingJobs: actionProcessingJobs,
      updateStatusAction: updateStatusAction,
      cancelReasonAction: cancelReasonAction,
    },
    dispatch
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(JobsComponent);



// WEBPACK FOOTER //
// ./src/components/Assigned/JobsComponent.js